export default __webpack_public_path__ + "images/crypto-lottery_ee8ba2.png";